import React from 'react';
import DefaultSettingsSection from './sections/DefaultSettingsSection';
import WatermarkSettingsSection from './sections/WatermarkSettingsSection';
import AnnotationSettingsSection from './sections/AnnotationSettingsSection';
import PreviewSection from './sections/PreviewSection';

interface ServiceSettingsTabProps {
  serviceSettings: any;
  selectedFileName: string;
  setSelectedFileName: (name: string) => void;
  onSettingsChanged: () => void;
}

const ServiceSettingsTab: React.FC<ServiceSettingsTabProps> = ({
  serviceSettings,
  selectedFileName,
  setSelectedFileName,
  onSettingsChanged,
}) => {
  if (serviceSettings.isLoading) {
    return (
      <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
        設定を読み込んでいます...
      </div>
    );
  }

  return (
    <>
      <DefaultSettingsSection
        serviceSettings={serviceSettings}
        onSettingsChanged={onSettingsChanged}
      />

      <div style={{ fontWeight: 'bold', fontSize: 16, margin: '8px 0', color: '#222' }}>ウォーターマーク＆注釈</div>

      <WatermarkSettingsSection
        serviceSettings={serviceSettings}
        onSettingsChanged={onSettingsChanged}
      />

      <AnnotationSettingsSection
        serviceSettings={serviceSettings}
        onSettingsChanged={onSettingsChanged}
      />

      <PreviewSection
        serviceSettings={serviceSettings}
        selectedFileName={selectedFileName}
        setSelectedFileName={setSelectedFileName}
        onSettingsChanged={onSettingsChanged}
      />
    </>
  );
};

export default ServiceSettingsTab;
